var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 124,
    viewBox: "0 0 35 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.29288 115.293C-0.097637 115.683 -0.0976252 116.317 0.292906 116.707L6.65698 123.071C7.04752 123.461 7.68068 123.461 8.0712 123.071C8.46172 122.68 8.4617 122.047 8.07117 121.657L2.41421 116L8.07096 110.343C8.46148 109.952 8.46147 109.319 8.07094 108.929C7.68041 108.538 7.04724 108.538 6.65672 108.929L0.29288 115.293ZM33 -1.58685e-06L33 106L35 106L35 -1.68603e-06L33 -1.58685e-06ZM24.0002 115L0.999982 115L1.00002 117L24.0002 117L24.0002 115ZM33 106C33 110.97 28.9707 114.999 24.0002 115L24.0002 117C30.0753 116.999 35 112.075 35 106L33 106Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep34);
export default __webpack_public_path__ + "static/media/laptop_step_3_4.cf6a75eda491979d55a16441f6b4fe00.svg";
export { ForwardRef as ReactComponent };